import React from 'react';
import { connect } from "react-redux";
import { getPractisionersList, editPractitioner, deletePractitioner } from '../../../services/facility/action'
import { NavLink } from "react-router-dom";
import DeleteModel from '../../common/Model/deleteModel';
import Pagination  from '../../common/pagination';
import { onlyAlphabets, onlyNumbers} from "../../common/keyValidation"

class PractitionerVUD extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            facilityEmail: "",
            access_token: "",
            practitionersList: [],
            id: "",
            firstName: "",
            lastName: "",
            email: "",
            title: "",
            npiNumber: "",
            practiceType: "",
           // facilityEmail: "",
            editStatus: false,
            popUpEdit: false,
            userType: "",
            openPopUp: false,
            practitionerId: "",
            pageOfItems : [],
            errors: {
                firstName: "",
                lastName: "",
                email: "",
                title: "",
                npiNumber: "",
            },
            firstNameValid: false,
            lastNameValid: false,
            emailValid: false,
            npiValid: false,
            degreeValid: false,
            formValid: false

        }
    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }

    componentDidMount() {
        let facilityEmail = this.props.profileDetails.commonUser.email
        let userType = this.props.profileDetails.commonUser.userType
        let userId = this.props.profileDetails.commonUser.userId
        let access_token = this.props.loginDetails;

        this.setState({
            access_token,
            facilityEmail,
            userType
        })

      
        this.props.getPractisionersList(access_token, userId);

    }


    componentWillReceiveProps = nextProps => {
        if (nextProps.getPractitionersDetails) {
            let data = nextProps.getPractitionersDetails.practionerList;
     
            this.setState({
                practitionersList: data,

            })
        }
        if (nextProps.editPractitionerSuccess) {
            this.setState({
                popUpEdit: false
            })
        }
    }





    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }
        , () => {
        this.validateField(name, value);
        });
    };

    validateField(fieldName, value) {
       
        const {
            errors,
            firstNameValid,
            lastNameValid,
            emailValid,
            npiValid,
            degreeValid

         } = this.state;

        let fieldValidationErrors = errors;
        let firstNamevalid = firstNameValid;
        let lastNamevalid = lastNameValid;
        let emailvalid = emailValid;
        let npivalid = npiValid;
        let degreevalid = degreeValid


        switch (fieldName) {

            case "firstName":
                firstNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.firstName = firstNamevalid
                    ? ""
                    : "First Name should be 3 to 20 characters";
           
                break;
            case "lastName":
                lastNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.lastName = lastNamevalid
                    ? ""
                    : "Last Name should be 3 to 20 characters";
                break;
            case "npiNumber":
                npivalid = value.match(/^\d{10}$/);
                fieldValidationErrors.npiNumber = npivalid
                    ? ""
                    : "Please enter valid NPI number";
                break;

            case "email":
                emailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.email = emailvalid
                    ? ""
                    : " Please enter valid Email Address";
                break;
            case "title":
                degreevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.title = degreevalid
                    ? ""
                    : "Enter you designation here";
                break;
          default:
          break;
        }
   
        this.setState(
            {
                errors: fieldValidationErrors,
                firstNameValid: firstNamevalid,
                lastNameValid: lastNamevalid,
                emailValid: emailvalid,
                npiValid: npivalid,
                // degreeValid : degreevalid,
            },
            this.validateForm
        );
    }




    validateForm() {
        const {
         npiValid,
            lastNameValid,
            firstNameValid,
            emailValid,
      } = this.state;
        this.setState({

            formValid:
            lastNameValid &&
            firstNameValid &&
            emailValid &&
            npiValid
        });
    } 







    updatePractitioner = (e) => {
        e.preventDefault();
        const {
            facilityEmail,
            access_token,
            id,
            firstName,
            lastName,
            email,
            title,
            npiNumber,
            practiceType,
        } = this.state;
        let Payload = {
            facilityEmail,
            id,
            firstName,
            lastName,
            email,
            title,
            npiNumber,
            practiceType,
        }

        let userId = this.props.profileDetails.commonUser.userId
      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUp: false,
        })
 
        this.props.editPractitioner(access_token, userId, Payload);
    }
    openPop = () => {
       // document.body.classList.add('modal-open');

        this.setState({
            openPopUp: true,

        })
    }
    closePop = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUp: false
        })
    }
    editPractitioner = (e, data) => {
        
        // e.preventDefault();
        const {
            id,
            firstName,
            lastName,
            email,
            title,
            npiNumber,
            
        } = data
 
         let  errors = this.state.errors
         errors.firstName = "" ;
         errors.lastName = "" ;
         errors.email = "" ;
         errors.title = "" ;
         errors.npiNumber = "" ;




        this.setState({
            editStatus: true,
            id,
            firstName,
            lastName,
            email,
            title,
            npiNumber,
            "practiceType": "",
            errors,
            firstNameValid: true,
            lastNameValid: true,
            emailValid: true,
            npiValid: true,
            degreeValid: true,
            formValid:true
        }, () => {
          //  document.body.classList.add('modal-open');

            this.setState({
                popUpEdit: true
            })
    
        })
    }
    openPopDel = (id) => {
      //  document.body.classList.add('modal-open');

        this.setState({
            openPopUpDel: true,
            practitionerId: id,
        })

    }

    closePopDel = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUpDel: false
        })
    }
    deletePractitioner = (e, id) => {
        e.preventDefault();
        let userId = this.props.profileDetails.commonUser.userId
        let access_token = this.state.access_token
       // document.body.classList.remove('modal-open');

        this.setState({
            openPopUpDel: false
        })
  
        this.props.deletePractitioner(access_token, userId, id);
    }

    render() {
     
        const {
            firstName,
            lastName,
            email,
            title,
            npiNumber,
            errors,
            formValid
        } = this.state;
        return (
            <React.Fragment>

                <div className="row tab-pane " id="Practitioners">
                    <div className="col-md-12 col-lg-12">
                        <NavLink to="/Practitioners" >
                            <button className="pull-right set-edit-btn btnDefault"><i className="fa fa-plus-circle" aria-hidden="true"></i> Add New Practitioners</button>
                        </NavLink>
                    </div>

                    <div className="col-md-12 col-lg-12 mt-2">
                        <div className="table-responsive">
                            <table className="table commonTable  table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Degree</th>
                                        <th>NPI Number</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.pageOfItems.length > 0 ?
                                        this.state.pageOfItems.map((Practitioner, id) => {
                                            return (
                                                <tr key={id}>
                                                    <td>{Practitioner.firstName}</td>
                                                    <td>{Practitioner.lastName}</td>
                                                    <td>{Practitioner.email}</td>
                                                    <td>{Practitioner.title}</td>
                                                    <td>{Practitioner.npiNumber}</td>
                                                    <td className="text-center set-icon">
                                                        <a onClick={(e) => this.editPractitioner(e, Practitioner)} title="Edit" className="model-btn"><i className="fa fa-pencil set-edit" aria-hidden="true"></i></a>
                                                        <a onClick={() => this.openPopDel(Practitioner.id)} title="Delete" className="model-btn"><i className="fa fa-trash set-del" aria-hidden="true"></i></a>

                                                        {/* {(e) => this.deletePractitioner(e,Practitioner.id)} */}
                                                    </td>
                                                </tr>

                                            )
                                        }) : <tr style={{ background: "transparent" }}><td colspan="6"><img src="images/no-record-found.png" width="180px" style={{ opacity: "0.6" }} /></td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>

   <Pagination items={this.state.practitionersList}   onChangePage={this.onChangePage} />


                        <DeleteModel header="Delete" text="Are you sure you want to delete?" page="deletePractitioner" status={this.state.openPopUpDel} confirmOkay={(e) => this.deletePractitioner(e, this.state.practitionerId)} closePop={this.closePopDel} />
                    </div>
                </div>

                {this.state.popUpEdit &&
                    <div className="modal fade in " id="editdata" role="dialog">
                        <div className="modal-dialog">

                            {/* <!-- Modal content--> */}
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={() => { this.setState({ popUpEdit: false }) }} data-dismiss="modal">&times;</button>
                                    <h4 className="modal-title header-title text-center">Edit Practitioners</h4>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label>FirstName</label>
                                                <input type="text" value={firstName} name="firstName"  onKeyPress={onlyAlphabets} onChange={this.handleChange} placeholder="FirstName" className="form-control" />
                                                <span className="error-red">{errors.firstName}</span>
                                            </div>

                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label>Last Name</label>
                                                <input type="text" value={lastName} name="lastName"  onKeyPress={onlyAlphabets} onChange={this.handleChange} placeholder="Last Name" className="form-control" />
                                                <span className="error-red">{errors.lastName}</span>
                                            </div>

                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label> Email</label>
                                                <input type="text" value={email} name="email" onChange={this.handleChange} placeholder="Email" className="form-control" />
                                                <span className="error-red">{errors.email}</span>
                                            </div>

                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label> Degree</label>
                                                <input type="text" value={title} name="title" onChange={this.handleChange} onKeyPress={onlyAlphabets} placeholder="Title" className="form-control" />
                                                <span className="error-red">{errors.title}</span>                                            
                                            </div>

                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label> NPI Number</label>
                                                <input type="text" value={npiNumber} name="npiNumber" onKeyPress={onlyNumbers} onChange={this.handleChange} placeholder="NPI Number" className="form-control" />
                                                <span className="error-red">{errors.npiNumber}</span>                                                                                       
                                            </div>

                                        </div>





                                    </div>

                                </div>
                                <div className="model-btn text-center mb-3">
                                    <button type="button" disabled={!formValid} className="btnDefault" onClick={this.openPop} >Update</button>
                                    <button type="button" className="btnDefault" onClick={() => { this.setState({ popUpEdit: false }) }} >Cancel</button></div>
                            </div>

                            <DeleteModel header="Edit" text="Are you sure you want to edit?" page="editPractitioner" status={this.state.openPopUp} confirmOkay={this.updatePractitioner} closePop={this.closePop} />


                        </div>

                    </div>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getPractitionersDetails: state.facilityReducer.getPractitionersDetails,
    getPractitionersStatus: state.facilityReducer.getPractitionersStatus,
    editPractitionerSuccess: state.facilityReducer.editPractitionerSuccess,
    deletePractitionerStatus: state.facilityReducer.deletePractitionerStatus
});

const mapDispatchToProps = dispatch => ({
    getPractisionersList: (token, userId, ) => dispatch(getPractisionersList(token, userId)),
    // addEmploye : (Payload, ) => dispatch( addEmploye(Payload, )),
    editPractitioner: (token, userId, Payload, ) => dispatch(editPractitioner(token, userId, Payload)),
    deletePractitioner: (token, userId, id, ) => dispatch(deletePractitioner(token, userId, id)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PractitionerVUD); 